export const sumByArr = (prev: number, next: number) => prev + next;
